import { Routes } from '@angular/router';
import { AuthorizationGuard } from '@fpr/core/guards/authorization.guard';
import { RouteData } from '@fpr/core/models/route.models';
import { ViewName } from './core/models/session.models';
import { SessionGuard } from './core/guards/session.guard';

export const cancelRoutes: Routes = [
    {
        path: 'party',
        loadChildren: () => import('./+create-party/create-party.routes'),
        canActivate: [AuthorizationGuard, SessionGuard],
        data: {
            pageTitle: 'Cancel Selections',
            check: ['selectedEntitlement'],
            returnTo: ViewName.RESERVATION_DETAILS,
            analyticsPageKey: 'wdw.site.admissionreservation.cancel-party',
            analyticsAutoTrack: false
        } as RouteData
    }
];
